// @ts-check
import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import lazyWithRetry from "./utils/lazyWithRetry";
//import { loadStripe } from "@stripe/stripe-js";
//import { Elements } from "@stripe/react-stripe-js";
//const stripePromise = loadStripe(process.env.STRIPE_PUBLIC_KEY);
const ModalSwitch = lazyWithRetry(() => import("./ModalSwitch"));

// import ModalSwitch from "./ModalSwitch";
import { LastLocationProvider } from "react-router-last-location";
import CenterElement from "./components/common/layout/CenterElement";
import { QACOPILOT_WIDGET } from "./constants/featureFlags";
import RouteChangeTracker from "./components/common/RouteChangeTracker";

const Router = () => {
  // return null;

  return (
    <div className="App">
      <main>
        {/* <Elements stripe={stripePromise}> */}
        <BrowserRouter>
          <LastLocationProvider>
            <RouteChangeTracker />
            <Suspense
              fallback={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                  }}
                >
                  <span className="loader" />
                </div>
              }
            >
              <Route component={ModalSwitch} />
            </Suspense>
          </LastLocationProvider>
        </BrowserRouter>
        {QACOPILOT_WIDGET ? (
          <button
            type="button"
            className="qa-copilot-floating"
            aria-label="QA Copilot"
          >
            <img
              src="/static/qacopilot_avatar_small.png"
              alt="QA Copilot"
              className="qa-copilot-floating__avatar"
            />
          </button>
        ) : null}
        {/* </Elements> */}
      </main>
    </div>
  );
};

export default Router;
